import { TOGGLE_LIST, SET_SUMMARY } from '@/actions/types';

const initialState = {
  list: true,
  summary: null
};

export default function summaryReducer (state = initialState, { type, data }) {
  switch (type) {

  case TOGGLE_LIST:
    return ({
      ...state,
      list: data
    });
  case SET_SUMMARY:
    return ({
      ...state,
      summary: data
    });
  default:
    return state;
  }
}
